import { render, staticRenderFns } from "./load_video.vue?vue&type=template&id=2e8bf05e&"
import script from "./load_video.vue?vue&type=script&lang=js&"
export * from "./load_video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports